module.exports = __webpack_public_path__ + "19658706.gif";